import * as React from 'react';
import {Icon, SemanticICONS, SemanticSIZES} from "semantic-ui-react";

export interface IButtonProps {
    onClick?: React.MouseEventHandler<{}>;
    label?: React.ReactNode;
    labelPosition?: "before" | "after";
    icon?: SemanticICONS;
    style?: React.CSSProperties;
    disabled?: boolean;
    raised?: boolean;
    className?: string;
    /** A button can be aligned to the left or right of its container. */
    floated?: 'left' | 'right';

    /** A button can have different sizes. */
    size?: SemanticSIZES;
    children?: React.ReactElement<any> | React.ReactElement<any>[];
    id?: string;
}

export const Button: React.SFC<IButtonProps> = (props: IButtonProps) => {
    // If neither label nor icon is applied, throw an error at run time
    if (!props.label && !props.icon && !props.children) {
        throw new Error("Either property label, icon or children of Button is required!");
    }

    let cont: any = (
        <>
            {props.icon ? <Icon name={props.icon}/> : null}
            {props.label || null}
        </>
    );

    if (props.label && props.label !== null)
        if (props.labelPosition === 'before')
        {
            cont = (
                <>
                    {props.label}
                    {props.icon ? <Icon name={props.icon} className='after'/> : null}
                </>
            );
        } else if (props.labelPosition === 'after') {
            cont = (
                <>
                    {props.icon ? <Icon name={props.icon} className='before'/> : null}
                    {props.label}
                </>
            );
        }

    if (props.children) {
        cont = props.children;
    }

    let className: string = props.disabled !== undefined && props.disabled === true ? 'btn disabled' : 'btn';

    return (
        <button
            style={props.style}
            id={props.id}
            onClick={props.onClick}
            className={className + ' ' + props.className}
            disabled={props.disabled}
        >
            {
                cont
            }
        </button>
    );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.tsx